<template>
  <div class="tabs">
    <ul class="tabs--head">
      <li
        v-for="(tab, index) in onlyTabs"
        :key="tab.title"
        :class="{
          tab__active: selectedIndex === index
        }"
        class="tab"
        @click="selectTab(index)"
      >
        <slot :name="`tab-title-${index}`" :title="tab.title" :tabObj="tab">
          {{ tab.title }}
        </slot>
      </li>
    </ul>
    <div class="tabs--content">
      <!-- SLOT DEFAULT -->
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Componente padrão de Tabs
 * Utiliza o componente Tab para o conteúdo - @/components/_base/patterns/Tab
 */
export default {
  name: 'Tabs',
  data() {
    return {
      selectedIndex: 0, // indíce da tab selecionada
      tabs: [] // array com as tabs existentes
    }
  },
  computed: {
    /** Retorna somente filhos que são tabs */
    onlyTabs() {
      return this.tabs.filter((item) => item.$options.name === 'Tab')
    }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    /**
     * Inicializa com a tab selecionada
     * se não for setada inicia com a 0
     */
    this.selectedIndex = Math.max(
      0,
      this.tabs.findIndex((item) => item.active)
    )
    this.selectTab(this.selectedIndex)
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i

      /** Percorre todas as tabs */
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i
      })

      /** Envia tab selecionada para component pai */
      this.$emit('changeTab', this.selectedIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  &--head {
    display: flex;
    margin: 0 40px;
    list-style: none;
    border-bottom: 1px solid $gray-border;

    .tab {
      padding: 12px 30px 18px;
      border-radius: 4px 4px 0 0;
      font-size: font-size('size-medium');
      box-shadow: 0 -4px 0 -2px $gray-mid inset;
      color: $gray-dark;
      font-weight: font-weight('weight-light');
      cursor: pointer;
      transition: color $color-anim linear, box-shadow $color-anim linear,
        background-color $color-anim linear;

      &:hover {
        color: $primary;
        font-weight: font-weight('weight-medium');
        box-shadow: 0 -4px 0 -2px $primary inset;
        &:not(.tab__active) {
          background-color: #f1f1f1;
          color: $gray-dark;
          box-shadow: 0 -4px 0 -2px $gray-dark inset;
        }
      }

      &__active {
        color: $primary;
        background-color: $white;
        font-weight: font-weight('weight-medium');
        box-shadow: 0 -4px 0 -2px $primary inset;
      }
    }
  }
  /**
  * Espacamento padrao
  * Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=0%3A1
  */
  &--content {
    background-color: $white;
    padding: {
      top: card-spacing('top-large');
      right: card-spacing('side-large');
      bottom: card-spacing('bottom-large');
      left: card-spacing('side-large');
    }
  }
}
.title-image {
  vertical-align: sub;
}
</style>
